import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Image, Select, message, Radio } from "antd";
import {
  req_single_people,
  req_config_gsm_gate_status,
  req_add_gsm_singer_enrolment,
} from "../../api";
import { formateDate } from "../../utils/dateUtil";
import { usrRole } from "../../utils/dataUtil";

class SignerEnrolmentSelf extends Component {
  state = {
    userLevel: "NORMAL",
    loading: false,
    staff: {
      Cellphone: "",
      DepartmentTwName: "",
      TwId: "",
      TwName: "",
    },
    item: {
      StaffType: "masses",
      SchoolGateLocation: "NONE",
      DepartmentMainName: "",
      StaffCode: "",
      StaffName: "",
      SignUserCode: "",
      SignStatus: "IN",
    },
    items: [],
    picUrl: "",
    identity: "student",
    gateStatus: "OFF",
    gateLocation: "NONE",
    SignStatus: "IN",
    isDisabled: false,
  };

  UNSAFE_componentWillMount() {
    this.api_init_data();
  }

  api_init_data = async () => {
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_single_people(userCode, token);
    //console.log(result);
    const picUrl =
      userCode.length < 7
        ? "https://rm.tut.edu.tw/ab/DisplaySmallPicture.ashx?p=pic/" +
          userCode +
          ".jpg&w=80&h=100"
        : "https://stu95.tut.edu.tw/SC2008/PHOTO/" + userCode + ".jpg";
    const identity = userCode.length < 7 ? "teacher" : "student";
    this.setState({ picUrl, identity, staff: result });
    //console.log(picUrl);
  };

  api_gate_status = async (userLevel) => {
    const { token, userCode } = this.props.user;
    const result = await req_config_gsm_gate_status(userCode, userLevel, token);
    if (result.total > 0) {
      const item = result.data[0];
      const { GateStatus } = item;
      this.setState({ gateStatus: GateStatus });
      if (GateStatus === "OFF") {
        message.error("未開放登記!!");
      }
    }
  };

  api_add_item = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_gsm_singer_enrolment(item, token);
    if (result.status === "success") {
      message.success("登記成功");
    } else {
      message.error("登記失敗");
    }
  };
  //////////////////////////////////////////////////

  handle_change = (value) => {
    //console.log(`selected ${value}`);
    switch (value) {
      case "NONE":
        this.setState({ gateStatus: "OFF", gateLocation: "NONE" });
        break;
      case "第一校門":
        this.api_gate_status("GATEA");
        this.setState({ gateLocation: "GATEA" });
        break;
      case "第二校門":
        this.api_gate_status("GATEB");
        this.setState({ gateLocation: "GATEB" });
        break;
      default:
        this.setState({ gateStatus: "OFF", gateLocation: "NONE" });
        break;
    }
  };

  handle_register = () => {
    this.disableButton();
    const { identity, gateLocation, staff, SignStatus } = this.state;
    const { userCode } = this.props.user;
    const row = {
      StaffType: identity,
      SchoolGateLocation: gateLocation,
      DepartmentMainName: staff.DepartmentTwName,
      StaffCode: staff.TwId,
      StaffName: staff.TwName,
      SignUserCode: userCode,
      StaffCellphone: staff.Cellphone,
      SignDescription: "",
      SignStatus: SignStatus,
    };
    this.api_add_item(row);
  };

  disableButton = () => {
    this.setState({ isDisabled: true }, () =>
      setTimeout(() => {
        this.setState({ isDisabled: false });
      }, 600000)
    );
  };

  onRadioChange = (e) => {
    // console.log("radio checked", e.target.value);
    this.setState({
      SignStatus: e.target.value,
    });
  };

  //////////////////////////////////////////////////
  render() {
    const {
      picUrl,
      identity,
      gateStatus,
      gateLocation,
      isDisabled,
      SignStatus,
    } = this.state;

    return (
      <Card>
        <div style={{ width: "100%" }}>
          <div
            style={{
              fontSize: "1.5em",
              textAlign: "center",
              width: "250px",
              border: "1px solid white",
              margin: "15px auto",
              padding: "5px",
              borderRadius: "5px",
              backgroundColor: "#26004d",
              color: "white",
              boxShadow: "1px 2px 9px #000",
            }}
          >
            {identity === "teacher" ? <p>教職員身份</p> : <p>學生身份</p>}
            <Image width={80} src={picUrl} />
            <p></p>
            <Select
              defaultValue={gateLocation}
              style={{ width: 200, backgroundColor: "LightCyan" }}
              onChange={this.handle_change}
            >
              <Select.Option value="NONE">請選擇登記地點</Select.Option>
              <Select.Option value="第一校門">
                前門|第一校門|中正路
              </Select.Option>
              <Select.Option value="第二校門">
                後門|第二校門|正南五路
              </Select.Option>
            </Select>
            <p></p>
            <Radio.Group
              onChange={this.onRadioChange}
              defaultValue={SignStatus}
            >
              <Radio value="IN" style={{ color: "white" }}>
                進校
              </Radio>
              <Radio value="OUT" style={{ color: "white" }}>
                離校
              </Radio>
            </Radio.Group>
            {gateStatus === "OFF" ? (
              <p></p>
            ) : (
              <div>
                <p></p>
                <button
                  className={"btn btn-warning"}
                  onClick={this.handle_register}
                  disabled={isDisabled}
                >
                  <i className="fa fa-location-arrow"></i> 開放登記
                </button>
                {isDisabled === true ? (
                  <div>
                    <span> {formateDate(new Date())}</span>
                    <div
                      style={
                        SignStatus === "IN"
                          ? { backgroundColor: "#ffb3d9", color: "#943126" }
                          : { backgroundColor: "#ABEBC6", color: "#0B5345" }
                      }
                    >
                      {SignStatus === "IN" ? "入校" : "離校"}登記成功
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            )}
          </div>
        </div>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SignerEnrolmentSelf);
